import axios from "axios";
import {AppDispatch, RootState} from "../../app/store";
import {ILLTag} from "../../interfaces/Tag";
import {SET_DPI, SET_EMPLOYEES, SET_LABEL_SIZES, SET_RECID, SET_TAGS, SET_TEMPLATES} from "../MainReducer";
import {ILabelSize} from "../../interfaces/ILabelSize";
import {showErrorToast, showToast} from "../../utils/showToast";
import { SET_COUNTER_DATA, SET_INVENT_DATA, SET_PRINT_DATA } from "./CompanyDataReducer";
import { IInventTable } from "../../interfaces/InventTable";
import { ICounterTable } from "../../interfaces/CounterTable";
import { IPrintTable } from "../../interfaces/PrintTable";
import i18n from "i18next";

export const GetAllCompanyData = (company: number = -1) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      let companyId = getState().auth.companyId;
      let role = getState().auth.role;
      if (company !== undefined && company !== null && company !== -1) {
        companyId = company;
      }
 if( companyId === null || companyId === undefined) return;

      dispatch(GetAllTags(companyId));
      dispatch(GetAllDpiValues(companyId));
      dispatch(GetAllLabelSizes(companyId));
      
      if(role === "admin" || role === "super_admin") dispatch(GetAllEmployees(companyId));
      dispatch(GetAllInvent(companyId));
      dispatch(GetAllCounterData(companyId));
      dispatch(GetAllPrintData(companyId));
    } catch (error) {
      showErrorToast(i18n.t("get_company_data_err"));
    }
  };
};

export const GetAllDefaultData = () => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      dispatch(GetAllTags(-1));
      dispatch(GetAllDpiValues(-1));
      dispatch(GetAllLabelSizes(-1));
    } catch (error) {
      showErrorToast(i18n.t("no_data"));
    }
  };
};

//---------------------------------Tags----------------------------------------------
export const GetAllTags = (companyId: number) => {
  return async (dispatch: any, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      let url = "api/Tags/" + companyId;
      if(companyId === -1) url = "api/Tags/default";
      const response = await axios.get(url);
      if (response.data.success) {
        dispatch({type: SET_TAGS, allTags: response.data.data, textTags: response.data.textTags, barcodeTags: response.data.barcodeTags, imgTags: response.data.imgTags, techTags: response.data.techTags});
      }
    } catch (error) {
      // showErrorToast("Klaida kraunant žymas");
    }
  };
};

export const CreateNewTag = (tag: ILLTag, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      tag.companyid = companyId;
      const response = await axios.post("api/Tags", tag);
      if (response.data.success) {
        dispatch(GetAllTags(companyId));
        showToast("success", "check circle", i18n.t('success'), i18n.t("create_tag_success"));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const UpdateTag = (tag: ILLTag, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      tag.companyid = companyId;
      const response = await axios.put("api/Tags", tag);
      if (response.data.success) {
        dispatch(GetAllTags(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const DeleteTag = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Tags/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllTags(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

//---------------------------------DPI----------------------------------------------
export const GetAllDpiValues = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      let url = "api/Dpi/" + companyId;
      if(companyId === -1) url = "api/Dpi/default";
      const response = await axios.get(url);
      if (response.data.success) {
        dispatch({type: SET_DPI, dpiValues: response.data.data});
      } 
    } catch (error) {
      // showErrorToast("Klaida kraunant DPI reikšmes");
    }
  };
};

export const CreateNewDpiValue = (dpi: number, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.post("api/Dpi", {dpi, companyId});
      if (response.data.success) {
        dispatch(GetAllDpiValues(companyId));
        showToast("success", "check circle", i18n.t('success'), i18n.t("create_dpi_success"));
      } else {
        showErrorToast(i18n.t("create_dpi_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("create_dpi_err"));
    }
  };
};

export const DeleteDpiValue = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Dpi/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllDpiValues(companyId));
      } else {
        showErrorToast(i18n.t("delete_dpi_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("delete_dpi_err"));
    }
  };
};
//---------------------------------Label Sizes----------------------------------------------
export const GetAllLabelSizes = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      let url = "api/LabelSize/" + companyId;
      if(companyId === -1) url = "api/LabelSize/default";
      const response = await axios.get(url);
      if (response.data.success) {
        dispatch({type: SET_LABEL_SIZES, labelSizes: response.data.data});
      } 
    } catch (error) {
      // showErrorToast("Klaida kraunant etikečių dydžius");
    }
  };
};

export const CreateNewLabelSize = (labelSize: ILabelSize, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      labelSize.companyid = companyId;
      const response = await axios.post("api/LabelSize", labelSize);
      if (response.data.success) {
        dispatch(GetAllLabelSizes(companyId));
        showToast("success", "check circle", i18n.t('success'), i18n.t("create_labelsize_success"));
      } else {
        showErrorToast(i18n.t("create_labelsize_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("create_labelsize_err"));
    }
  };
};

export const UpdateLabelSize = (labelSize: ILabelSize, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      labelSize.companyid = companyId;
      const response = await axios.put("api/LabelSize", labelSize);
      if (response.data.success) {
        dispatch(GetAllLabelSizes(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const DeleteLabelSize = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/LabelSize/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllLabelSizes(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};
//---------------------------------Employees----------------------------------------------
export const GetAllEmployees = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.get("api/Employees/" + companyId);
      if (response.data.success) {
        dispatch({type: SET_EMPLOYEES, employees: response.data.data});
      } 
    } catch (error) {
      //showErrorToast("Klaida kraunant darbuotojus");
    }
  };
};

export const CreateNewEmployee = (email: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      let companyName = getState().auth.companyName;
      let companyId = getState().auth.companyId;
      if (!companyName) return;
      const model = {
        Email: email,
        Password: "",
        companyId: companyId,
        CompanyName: companyName,
      };
      const lang = localStorage.getItem("lang") || i18n.language || "lt";

      const response = await axios.post("api/Employees/" + lang, model);
      if (response.data.success) {
        dispatch(GetAllEmployees(companyId));
      } else {
        showErrorToast(i18n.t("add_employee_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("add_employee_err"));
    }
  };
};

export const RemoveEmployee = (email: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Employees/" + email, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllEmployees(companyId));
      } else {
        showErrorToast(i18n.t("delete_employee_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("delete_employee_err"));
    }
  };
};

export const ChangeRole = (email: string, roleId: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.put(`api/Employees/changeRole`, { email, roleId, companyId });
      if (response.data.success) {
        dispatch(GetAllEmployees(companyId));
        showToast("success", "check circle", i18n.t('success'), i18n.t("change_role_success"));
      } else {
        showErrorToast(i18n.t("change_role_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("change_role_err"));
    }
  };
}

//--------------------------------Templates----------------------------------------------
export const GetAllTemplates = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      let url = "api/Templates/" + companyId;
      if(companyId === -1) url = "api/Templates/default";
      const response = await axios.get(url);
      if (response.data.success) {
        dispatch({type: SET_TEMPLATES, templates: response.data.data});
      } 
    } catch (error) {
      // showErrorToast("Klaida kraunant šablonus");
    }
  };
};

export const RenameTemplate = (id: string, name: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.put("api/Templates/" + companyId + "/" + id + "/" + name);
      if (response.data.success) {
        const currentTemplate = getState().refData.recid;
        if (currentTemplate.toString() === id.toString()) {
          dispatch({type: SET_RECID, recid: id, templateName: name});
        }
        dispatch(GetAllTemplates(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const DeleteTemplate = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Templates/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllTemplates(companyId));
      } else {
        showErrorToast(i18n.t("delete_template_err"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("delete_template_err"));
    }
  };
};

//---------------------------------Invent table----------------------------------------------
export const GetAllInvent = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.get("api/Invent/" + companyId);
      if (response.data.success) {
        dispatch({type: SET_INVENT_DATA, invent: response.data.data});
      } 
    } catch (error) {
    }
  };
};

export const CreateNewInvent = (invent: IInventTable, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      invent.companyId = companyId;
      const response = await axios.post("api/Invent", invent);
      if (response.data.success) {
        dispatch(GetAllInvent(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("create_item_err"));
    }
  };
};

export const UpdateInvent = (invent: IInventTable, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      invent.companyId = companyId;
      const response = await axios.put("api/Invent", invent);
      if (response.data.success) {
        dispatch(GetAllInvent(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const DeleteInvent = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Invent/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllInvent(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};


//---------------------------------Counter table----------------------------------------------
export const GetAllCounterData = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.get("api/Counter/" + companyId);
      if (response.data.success) {
        dispatch({type: SET_COUNTER_DATA, counterData: response.data.data});
      } 
    } catch (error) {
    }
  };
};

export const CreateNewCounter = (counter: ICounterTable, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      counter.companyId = companyId;
      const response = await axios.post("api/Counter", counter);
      if (response.data.success) {
        dispatch(GetAllCounterData(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast(i18n.t("create_counter_err"));
    }
  };
};

export const UpdateCounter = (counter: ICounterTable, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      counter.companyId = companyId;
      const response = await axios.put("api/Counter", counter);
      if (response.data.success) {
        dispatch(GetAllCounterData(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

export const DeleteCounter = (id: string, companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.delete("api/Counter/" + id, {params: {companyId}});
      if (response.data.success) {
        dispatch(GetAllCounterData(companyId));
      } else {
        showErrorToast(i18n.t("error"), i18n.t(response.data.msg));
      }
    } catch (error) {
      showErrorToast();
    }
  };
};

//---------------------------------Print table----------------------------------------------
export const GetAllPrintData = (companyId: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if( companyId === null || companyId === undefined) return;
      const response = await axios.get("api/PrintTable/" + companyId);
      if (response.data.success) {
        dispatch({type: SET_PRINT_DATA, printData: response.data.data});
      } 
    } catch (error) {
    }
  };
};

export const InsertNewPrintHistory = (printData: IPrintTable) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if (!printData.companyId) return;
      const response = await axios.post("api/PrintTable/", printData);
      if (response.data.success) {
        dispatch(GetAllPrintData(printData.companyId));
      } 
    } catch (error) {
    }
  };
};